<template>
    <el-drawer
        title="已禁用成员"
        :size="1000"
        :close-on-press-escape="false"
        :visible.sync="drawer">
        <span slot="title" class="font14px text-bold">已禁用成员{{totalCnt>0?'（'+totalCnt+'）':''}}</span>
        <div class="p20 drawer-page">
            <div class="filter-bar">
                <el-form :inline="true" @submit.native.prevent="submitSearch">
                    <el-form-item label="成员：">
                        <el-input v-model.trim="tempQuery.search" clearable placeholder="根据成员姓名、手机号、邮箱关键字搜索" style="width: 360px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="data-list">
                <el-table
                    v-loading="dataLoading"
                    :data="dataList"
                    :default-sort = "{prop: 'operator_time', order: 'descending'}"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    @sort-change="handleSortChange">
                    <el-table-column
                        property="id"
                        align="center"
                        width="80"
                        label="ID">
                    </el-table-column>
                    <el-table-column
                        v-if="fields.includes('name')"
                        property="name"
                        align="center"
                        min-width="90"
                        label="姓名">
                        <template slot-scope="scope">
                            <span class="mr6">{{scope.row.name}}</span>
                            <span class="text-color-success" title="微信已绑定" v-if="scope.row.is_bind_wx=='1'">
                                <i class="iconfont icon-jt-wechat-fill vertical-bottom"></i>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="fields.includes('mobile')"
                        property="mobile"
                        align="center"
                        min-width="110"
                        label="手机号">
                        <template slot-scope="scope">
                            <span class="mr6">{{scope.row.mobile||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="fields.includes('group_name')"
                        property="group_name"
                        label="禁用前所属部门"
                        min-width="110"
                        align="center">
                        <template slot-scope="scope">
                            <span v-if="(scope.row.group_name_with_parent||'').length<=0">{{scope.row.group_name}}</span>
                            <template v-else>
                                <el-tooltip :content="scope.row.group_name_with_parent" placement="top">
                                    <span>{{scope.row.group_name}}</span>
                                </el-tooltip>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="200"
                        property="operator_time"
                        sortable="custom"
                        :sort-orders="['ascending','descending']"
                        label="禁用人与时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.operator_user_name||'--'}}</span>
                            <span class="ml20">{{scope.row.operator_time||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="fields.includes('create_time')"
                        property="create_time"
                        align="center"
                        sortable="custom"
                        :sort-orders="['ascending','descending']"
                        width="125"
                        label="创建时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.create_time||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="action" label="操作">
                        <template slot-scope="scope">
                            <el-dropdown @command="handleMemberCommand(scope.row,$event)">
                                    <span class="el-dropdown-link">
                                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="func.includes('grant_authorization')" command="auth">授权</el-dropdown-item>
                                    <el-dropdown-item v-if="func.includes('release_resource')" command="release">释放资源</el-dropdown-item>
                                    <el-dropdown-item v-if="func.includes('rollback_disable')" command="restore">还原</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-bar tac mt20">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="queryData.pn"
                    :page-sizes="[10, 30,60]"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>

            <MemberAuthModal ref="memberAuthModal" :user="actionUser"/>
            <MemberReleaseModal ref="memberReleaseModal" :user="actionUser"/>
            <MemberRestoreModal ref="memberRestoreModal" :user="actionUser" @update="updateList"/>
        </div>
    </el-drawer>
</template>

<script>
    import API from '@/api/department.js';
    import MemberAuthModal from '../modal/memberAuth';
    import MemberReleaseModal from '../modal/memberRelease';
    import MemberRestoreModal from '../modal/memberRestore';

    export default {
        name: "disabledUserDrawer",
        components:{
            MemberAuthModal,
            MemberReleaseModal,
            MemberRestoreModal,
        },
        props:{
            func:{
                type:Array,
                required:true,
            },
            fields:{
                type:Array,
                required:true,
            },
        },
        data(){
            return{
                drawer:false,
                dataLoading:false,
                queryData: {
                    search: '',
                    order_by:'operator_time',
                    order_type:'desc',
                    pn: 1,
                    rn: 10
                },
                tempQuery:{
                    search: '',
                },
                dataList:[],
                totalCnt:0,
                actionUser:{},

            }
        },
        methods:{
            showDrawer(){
                this.drawer = true;
                this.$nextTick(()=>{
                    this.getDataList();
                })
            },
            getDataList(){
                this.dataLoading = true;
                API.getDisabledUserList({
                    search: this.queryData.search,
                    order_by:this.queryData.order_by,
                    order_type:this.queryData.order_type,
                    pn: this.queryData.pn,
                    rn: this.queryData.rn,
                }).then(res => {
                    let resData = res.data||{};
                    this.dataLoading = false;
                    this.dataList = resData.list;
                    this.totalCnt = resData.totalCnt;

                }, (err) => {
                    console.log('getDisabledUserList error', err);

                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            submitSearch() {
                this.queryData.pn = 1;
                this.queryData.search = this.tempQuery.search;
                this.getDataList();
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            handleMemberCommand(data,val){
                switch (val) {
                    case 'auth':
                        this.actionUser = data;
                        this.$refs.memberAuthModal.showModal();
                        break;
                    case 'release':
                        this.actionUser = data;
                        this.$refs.memberReleaseModal.showModal();
                        break;
                    case 'restore':
                        this.actionUser = data;
                        this.$refs.memberRestoreModal.showModal();
                        break;
                }
            },
            updateList(){
                this.getDataList();
                this.$emit('update');
            },
            handleSortChange(column){
                this.queryData.order_type = column.order=='descending'?'desc':'asc';
                this.queryData.order_by = column.prop;
                this.queryData.pn =1;
                this.getDataList();
            },
        }
    }
</script>

<style scoped>
    ::v-deep .el-drawer__header{
        padding: 15px 20px;
        margin: 0;
        border-bottom: solid 1px #dcdee2;
    }

</style>
